const users = [
   {
      token: "2f9af542-c7a0-4bc3-9121-73dc758c9c11",
      email: "customer@purple.com",
      password: "lazyload",
      theme: "purple",
   },
   {
      token: "d8f36edb-a8a5-4dc4-8f5f-f8b60b3a7e6d",
      email: "customer@red.com",
      password: "lazyload",
      theme: "red",
   },
   {
      token: "5853db4d-74e0-4a81-97bb-ae03acf5eb09",
      email: "customer@blue.com",
      password: "lazyload",
      theme: "blue",
   },
];

function loadLocalStorage() {
   // return {
   //    token: "2f9af542-c7a0-4bc3-9121-73dc758c9c11",
   //    email: "customer@purple.com",
   //    password: "lazyload",
   //    theme: "purple",
   // };

   let token = localStorage.getItem("lazyStorageToken");
   let user = null;

   if (token) {
      user = users.find((element) => {
         return element.token === token;
      });
   }
   return user === undefined ? null : user;
}

function saveLocalStorage(user) {
   localStorage.setItem("lazyStorageToken", user.token);
}

function clearLocalStorage() {
   localStorage.setItem("lazyStorageToken", null);
}

function storeLocalStorage() {
   let value = localStorage.getItem("lazyStorage");

   if (value) {
      if (value[0] === "{") {
         value = JSON.parse(value);
      }
   }

   return value;
}

var index = {
   namespaced: true,
   state: {
      status: "",
      // token: localStorage.getItem("token") || "",
      user: loadLocalStorage(),
   },
   mutations: {
      auth_request(state) {
         state.status = "loading";
      },
      auth_success(state, user) {
         saveLocalStorage(user);
         state.status = "success";
         // state.token = token;
         state.user = user;
      },
      auth_error(state) {
         state.status = "error";
      },
      logout(state) {
         clearLocalStorage();
         state.status = "";
         state.user = null;
      },
   },
   actions: {
      async signIn({ commit }, { email, password }) {
         // Attempt to locate user
         const user = users.find((element) => {
            return element.email === email && element.password === password;
         });

         // Return error if user is not recognized

         if (user === undefined) {
            commit("auth_error");
            return null;
            // throw new SubmissionError({ _error: "invalidForm" });
         } else {
            commit("auth_success", user);
            return user;
            // asyncLogin();
            // setThemeByName(user.theme);
            // history.push('/mortgage');
            // window.alert( `You JUST submitted:\n\n${JSON.stringify( values, null, 2 )}` )
         }
      },
      async signOut({ commit }) {
         commit("logout");
         // return new Promise((resolve, reject) => {
         //   commit('logout')
         //   localStorage.removeItem('token')
         //   delete axios.defaults.headers.common['Authorization']
         //   resolve()
         // })
      },
   },
   getters: {
      isSignedIn: (state) => state.user !== null,
      authStatus: (state) => state.status,
   },
};

export default index;
export { storeLocalStorage };
